import * as types from '../actions/action-types';
import _ from 'lodash';

const defaults = {
  loading: true,
  data: [],
  dict: {},
  counts: getOverdoseCounts(),
  timeline: getOverdoseTimeline()
};

/**
 * Set initial data and loading false
 *
 * @param store
 * @param data
 * @returns {{loading: boolean, data: *, dict: *, counts: *}}
 */
function setData(store, data) {
  const dict = _.keyBy(data, 'cf');
  const counts = getOverdoseCounts(data);

  return {
    ...store,
    loading: false,
    data,
    dict,
    counts
  }
}

/**
 *
 * @param store
 * @param state
 * @param county
 * @returns {{timeline: *[]}}
 */
function setLocations(store, state, county) {
  const timeline = getOverdoseTimeline(state, county);

  return {
    ...store,
    timeline
  }
}

/**
 * Creates an object map with a property for each year of overdose data
 * that maps to an array of {range:2, count:10} objects representing the
 * number of counties in each overdose range per year.
 *
 * @returns {*}
 */
function getOverdoseCounts(data) {
  const years = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'];
  const ranges = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32];

  const rangeName = r => {
    return 'Overdose Rate ' + (r === 32 ? '>30' : (r - 2) + '-' + r);
  };

  return _.reduce(years, (output, year) => {

    output[+('20' + year)] = _.chain(ranges)
      .map(range => {
        const count = _.size(_.filter(data, d => d['od' + year] === range));
        return {
          group: rangeName(range),
          range: range,
          count: count
        };
      })
      .value();

    return output;
  }, {});
}

/**
 * Create
 * @param state
 * @param county
 * @returns {[]}
 */
function getOverdoseTimeline(state, county) {
  const years = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15'];

  return _.reduce(years, (output, year) => {
    return _.concat(output, [{
      id: 0,
      group: 'America',
      year: +('20' + year),
      overdoseRate: state ? state['usod' + year] : 0
    }, {
      id: state ? state.sf : null,
      group: state ? state.sn : 'State',
      year: +('20' + year),
      overdoseRate: state ? state['od' + year] : 0
    }, {
      id: county ? county.cf : null,
      group: county ? county.cn + ' ' + county.sa : 'County',
      year: +('20' + year),
      overdoseRate: county ? county['od' + year] : 0
    }])
  }, []);
}

export default (store = defaults, action) => {
  switch (action.type) {
    case types.COUNTY_DATA_RECEIVED:
      return setData(store, action.data);
    case types.UPDATE_OVERDOSE_LOCATIONS:
      return setLocations(store, action.state, action.county);
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/overdose-reducer.js